import { PRODUCTS_PER_PAGE } from 'constant';

import { GetProductsByFilterParams, GetProductTypeListParams } from 'types';

import { del, get, post } from './axios';

const URLS = {
  getProductsByType: 'products/items',
  getProductById: 'products/item',
  toggleFavoriteState: 'products/set-fav',
  getBrands: 'products/brands',
  getCategories: 'products/categories',
  getPurchasedProducts: 'products/purchased',
  shoppingCartAddNotify: '/products/in-stock-notify-add',
  shoppingCartRemoveNotify: '/products/in-stock-notify-remove'
};

const productsApi = {
  getProductsByType: (params: GetProductTypeListParams) =>
    post(URLS.getProductsByType, params),
  getProductById: (productId: string | number) => {
    const segment = encodeURIComponent(String(productId));
    return get(`${URLS.getProductById}/${segment}`, {
      pr_id: productId
    });
  },
  addProductToFavorite: (productId: number) =>
    post(URLS.toggleFavoriteState, { prid: productId }),
  deleteProductFromFavorite: (productId: number) =>
    del(URLS.toggleFavoriteState, { prid: productId }),
  getBrands: () => get(URLS.getBrands),
  getCategories: () => get(URLS.getCategories),
  getProductsByFilter: (
    params: GetProductsByFilterParams & { page?: number }
  ) => {
    const merged = {
      ...params,
      items: PRODUCTS_PER_PAGE
    };
    const usePost =
      merged.categories_slug != null || merged.brands_slug != null;
    if (usePost) {
      return post(URLS.getProductsByType, merged);
    }
    return get(URLS.getProductsByType, merged);
  },
  getPurchasedProducts: () => get(URLS.getPurchasedProducts),
  shoppingCartAddNotify: (prid: number) =>
    post(URLS.shoppingCartAddNotify, { prid }),
  shoppingCartRemoveNotify: (prid: number) =>
    post(URLS.shoppingCartRemoveNotify, { prid })
};

export default productsApi;
